import {Box, Card, CardContent, Link, Stack, Typography} from "@mui/material";
import {globalMaxWidth} from "../GlobalConfigs";
import {CalendarMonth} from "@mui/icons-material";
import React from "react";

export function FechasImportantes() {
    const Item = (props) => {
        const {headerText, contentText, linkText, linkHref} = props;
        return <Card variant='outlined' sx={{
            borderRadius: '15px', boxShadow: 5, width: 1, maxWidth: globalMaxWidth
        }}>
            <CardContent>
                <Stack direction='row' spacing={4} sx={{
                    p: {lg: 2, xs: 1}
                }}>
                    <Box alignItems='center' sx={{display: 'flex', justifyContent: 'center'}}>
                        <CalendarMonth sx={{
                            width: {lg: 50, sm: 35},
                            height: 1
                        }} color='primary'/>
                    </Box>

                    <Stack alignItems='left' spacing={2} sx={{
                        m: {lg: 2, xs: 1},
                    }}>
                        <Typography variant='h5' color='primary'>
                            {headerText}
                        </Typography>
                        <Typography variant="body1">
                            {contentText} <Link href={linkHref}> {linkText} </Link>
                        </Typography>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>;
    }
    return <Stack justifyContent='space-between' alignItems='center' spacing={2} sx={{
            width: 1, maxWidth:  globalMaxWidth
        }}>
        <Typography variant='h4' sx={{fontWeight: 700, color: 'primary.main', letterSpacing: 1, textAlign: 'center'}}>
            Fechas Importantes
        </Typography>
        <Item
            headerText='Convocatoria de Sesiones Especiales'
            contentText='Desde el 18 de noviembre de 2025 hasta el 15 de enero de 2026.'
        />
        <Item
            headerText='Call for papers'
            contentText='Se abrió el 15 de diciembre de 2025. Información disponible en '
            linkText='comunicaciones.'
            linkHref='/simposio/comunicaciones'
        />
        <Item
            headerText='Envío de papers'
            contentText='Desde el 2 de febrero hasta el 6 de abril de 2026 (plazo ampliado).'
            // contentText='Desde el 2 de febrero hasta el 18 de marzo de 2026. Para enviar contribuciones haga click aquí: '
            // linkText='inscripción'
            // linkHref='https://www.conftool.pro/ursi2026/'
        />
        <Item
            headerText='Notificación de aceptación'
            contentText='8 de mayo de 2026.'
        />
        <Item
            headerText='Entrega de la versión definitiva del paper'
            contentText='3 de junio de 2026.'
        />
        <Item
            headerText='Inscripciones al Simposio con tarifa reducida'
            contentText='22 de abril de 2026 a 5 de junio de 2026.'
        />

        <Item
            headerText='Inscripciones al Simposio con tarifa normal'
            contentText='6 de junio de 2026 a 19 de julio de 2026.'
        />
    </Stack>;
}